/**
 * FE#170 — derive a single, unambiguous fetch status for a generic DB slice.
 *
 * The slice only tracked `itemsLoading`/`itemsLoaded`. On a FAILED fetch the find
 * thunk set `itemsLoading=false` and left `itemsLoaded=false` with no error
 * recorded, so a failure was indistinguishable from "still loading" / "not
 * started" — the UI could sit on a spinner forever. With `itemsError` now
 * recorded on the slice, this collapses the flags into one status consumers can
 * branch on (show a retry on 'error' instead of a spinner).
 */
export type DbFetchStatus = 'idle' | 'loading' | 'error' | 'loaded';

export interface DbFetchStatusInput {
  itemsLoading?: boolean;
  itemsLoaded?: boolean;
  itemsError?: string | null;
}

export function deriveDbFetchStatus(state: DbFetchStatusInput | null | undefined): DbFetchStatus {
  if (!state) return 'idle';
  // A fetch in flight is 'loading' even if a prior error lingers (retry in
  // progress); the find thunk clears the error on start, so they rarely coexist.
  if (state.itemsLoading) return 'loading';
  if (state.itemsError) return 'error';
  if (state.itemsLoaded) return 'loaded';
  return 'idle';
}
